export const LoginCookieKey = "LoginToken"